module.exports = __webpack_public_path__ + "static/media/pending_evaluation_blue.92c020d2.svg";